import * as yup from 'yup';

export const SupportingDocumentSchema = yup.object().shape({
  identifier: yup.string().trim().required('Ingrese el documento de respaldo'),
  dateFrom: yup
    .date()
    .max(yup.ref('dateTo'), 'La fecha desde no puede ser mayor a la fecha hasta ')
    .required('Debe seleccionar una fecha desde'),
  dateTo: yup
    .date()
    .min(yup.ref('dateFrom'), 'La fecha hasta no puede ser menor a la fecha desde ')
    .required('Debe seleccionar una fecha hasta')
});

export const SupportingDocumentMonthlySchema = yup.object().shape({
  identifier: yup.string().trim().required('Ingrese el documento de respaldo'),
  dateFrom: yup
    .date()
    .max(yup.ref('dateTo'), 'La fecha desde no puede ser mayor a la fecha hasta ')
    .required('Debe seleccionar una fecha desde'),
  dateTo: yup
    .date()
    .min(yup.ref('dateFrom'), 'La fecha hasta no puede ser menor a la fecha desde ')
    .required('Debe seleccionar una fecha hasta'),
  locations: yup.array().of(yup.object().shape({}))
});
